const wording = {
  RESPONSE_MANAGE_PANEL_EXIT_WARN: "메시지 변경점을 저장하지 않아 현재 보여지는 메시지는 실제로 반영이 되지 않았습니다. 그래도 나가시겠습니까? \n (메시지 변경점을 저장하시려면 왼쪽 위 자동 저장 활성화 및 '메시지 변경점 저장'을 클릭하여 저장할 수 있습니다.)",
  RESPONSE_MANAGE_PANEL_WAIT_WARN: "변경된 메시지 데이터를 저장 중입니다. 잠시만 기다려주세요.",
  AS_STATUS_MSG_INIT: "메시지 변경점과 관련 메시지가 여기에 표시됩니다.",
  AS_STATUS_MSG_SAVING: "메시지 변경점 저장 중...",
  AS_STATUS_MSG_SAVE: "메시지 변경점 저장하기",
  AS_STATUS_MSG_ALL_SAVED: "모든 메시지 변경점이 저장되었습니다.",
  FILL_REMAIN_COL_TITLE: "컴포넌트의 개수와 컬럼이 나누어 떨어지지 않는 경우 맨 마지막 컴포넌트의 넓이를 남은 공간만큼 가득 채웁니다.", // 옵션의 '나머지 컬럼 채우기' 텍스트의 title 속성
}

export const getWording = (wordingName) => {
  return wording[wordingName]
}